// Códigos de país SII (aduana) — generado desde SimpleFacturaSDK CodigosAduana.Paises
// Usado para facturación de exportación (DTE 110).
export const COUNTRIES = [
  { code: 308, name: "Afghanistan" },
  { code: 518, name: "Albania" },
  { code: 563, name: "Alemania" },
  { code: 525, name: "Andorra" },
  { code: 140, name: "Angola" },
  { code: 242, name: "Anguila" },
  { code: 240, name: "Antigua Y Bbuda" },
  { code: 247, name: "Antillas Neerla" },
  { code: 302, name: "Arabia Saudita" },
  { code: 127, name: "Argelia" },
  { code: 224, name: "Argentina" },
  { code: 540, name: "Armenia" },
  { code: 243, name: "Aruba" },
  { code: 406, name: "Australia" },
  { code: 509, name: "Austria" },
  { code: 541, name: "Azerbaijan" },
  { code: 207, name: "Bahamas" },
  { code: 313, name: "Bahrein" },
  { code: 321, name: "Bangladesh" },
  { code: 204, name: "Barbados" },
  { code: 542, name: "Belarus" },
  { code: 420, name: "Belau" },
  { code: 514, name: "Belgica" },
  { code: 236, name: "Belice" },
  { code: 150, name: "Benin" },
  { code: 244, name: "Bermudas" },
  { code: 221, name: "Bolivia" },
  { code: 543, name: "Bosnia Hezgvina" },
  { code: 113, name: "Botswana" },
  { code: 220, name: "Brasil" },
  { code: 344, name: "Brunei" },
  { code: 527, name: "Bulgaria" },
  { code: 161, name: "Burkina Faso" },
  { code: 141, name: "Burundi" },
  { code: 318, name: "Butan" },
  { code: 129, name: "Cabo Verde" },
  { code: 315, name: "Cambodia" },
  { code: 149, name: "Camerun" },
  { code: 226, name: "Canada" },
  { code: 130, name: "Chad" },
  { code: 997, name: "Chile" },
  { code: 336, name: "China" },
  { code: 305, name: "Chipre" },
  { code: 202, name: "Colombia" },
  { code: 901, name: "Comb Y Lubric" },
  { code: 118, name: "Comoras" },
  { code: 144, name: "Congo" },
  { code: 333, name: "Corea Del Sur" },
  { code: 107, name: "Costa De Marfil" },
  { code: 211, name: "Costa Rica" },
  { code: 547, name: "Croacia" },
  { code: 209, name: "Cuba" },
  { code: 906, name: "Deposito Franco" },
  { code: 507, name: "Dinamarca" },
  { code: 155, name: "Djibouti" },
  { code: 231, name: "Dominica" },
  { code: 218, name: "Ecuador" },
  { code: 124, name: "Egipto" },
  { code: 213, name: "El Salvador" },
  { code: 341, name: "Emir Arab Unid" },
  { code: 163, name: "Eritrea" },
  { code: 548, name: "Eslovenia" },
  { code: 517, name: "Espana" },
  { code: 549, name: "Estonia" },
  { code: 139, name: "Etiopia" },
  { code: 401, name: "Fiji" },
  { code: 335, name: "Filipinas" },
  { code: 512, name: "Finlandia" },
  { code: 505, name: "Francia" },
  { code: 145, name: "Gabon" },
  { code: 102, name: "Gambia" },
  { code: 550, name: "Georgia" },
  { code: 108, name: "Ghana" },
  { code: 565, name: "Gibraltar" },
  { code: 232, name: "Granada" },
  { code: 520, name: "Grecia" },
  { code: 253, name: "Groenlandia" },
  { code: 425, name: "Guam" },
  { code: 215, name: "Guatemala" },
  { code: 566, name: "Guernsey" },
  { code: 104, name: "Guinea" },
  { code: 103, name: "Guinea Bissau" },
  { code: 147, name: "Guinea Ecuatrl" },
  { code: 217, name: "Guyana" },
  { code: 208, name: "Haiti" },
  { code: 515, name: "Holanda" },
  { code: 214, name: "Honduras" },
  { code: 342, name: "Hong Kong" },
  { code: 530, name: "Hungria" },
  { code: 317, name: "India" },
  { code: 328, name: "Indonesia" },
  { code: 307, name: "Irak" },
  { code: 309, name: "Iran" },
  { code: 506, name: "Irlanda" },
  { code: 516, name: "Islandia" },
  { code: 246, name: "Islas Cayman" },
  { code: 427, name: "Islas Cook" },
  { code: 567, name: "Islas De Man" },
  { code: 327, name: "Islas Maldivas" },
  { code: 424, name: "Islas Marianas" },
  { code: 164, name: "Islas Marshall" },
  { code: 418, name: "Islas Salomon" },
  { code: 403, name: "Islas Tonga" },
  { code: 245, name: "Islas Virg Brit" },
  { code: 249, name: "Islas Virg Eua" },
  { code: 306, name: "Israel" },
  { code: 504, name: "Italia" },
  { code: 205, name: "Jamaica" },
  { code: 331, name: "Japon" },
  { code: 568, name: "Jersey" },
  { code: 301, name: "Jordania" },
  { code: 551, name: "Kasajstan" },
  { code: 137, name: "Kenia" },
  { code: 552, name: "Kirgistan" },
  { code: 416, name: "Kiribati" },
  { code: 303, name: "Kuwait" },
  { code: 316, name: "Laos" },
  { code: 114, name: "Lesotho" },
  { code: 553, name: "Letonia" },
  { code: 311, name: "Libano" },
  { code: 106, name: "Liberia" },
  { code: 125, name: "Libia" },
  { code: 534, name: "Liechtenstein" },
  { code: 554, name: "Lituania" },
  { code: 888, name: "Los Demas" },
  { code: 532, name: "Luxemburgo" },
  { code: 345, name: "Macao" },
  { code: 555, name: "Macedonia" },
  { code: 120, name: "Madagascar" },
  { code: 329, name: "Malasia" },
  { code: 115, name: "Malawi" },
  { code: 133, name: "Mali" },
  { code: 523, name: "Malta" },
  { code: 128, name: "Marruecos" },
  { code: 250, name: "Martinica" },
  { code: 119, name: "Mauricio" },
  { code: 134, name: "Mauritania" },
  { code: 216, name: "Mexico" },
  { code: 417, name: "Micronesia" },
  { code: 556, name: "Moldova" },
  { code: 535, name: "Monaco" },
  { code: 337, name: "Mongolia" },
  { code: 252, name: "Monserrat" },
  { code: 561, name: "Montenegro" },
  { code: 121, name: "Mozambique" },
  { code: 326, name: "Myanmar Ex Bir" },
  { code: 998, name: "Nac Reputada" },
  { code: 159, name: "Namibia" },
  { code: 402, name: "Nauru" },
  { code: 320, name: "Nepal" },
  { code: 212, name: "Nicaragua" },
  { code: 131, name: "Niger" },
  { code: 111, name: "Nigeria" },
  { code: 421, name: "Niue" },
  { code: 513, name: "Noruega" },
  { code: 423, name: "Nueva Caledonia" },
  { code: 405, name: "Nueva Zelandia" },
  { code: 304, name: "Oman" },
  { code: 904, name: "Orig O Dest No" },
  { code: 999, name: "Otros" },
  { code: 324, name: "Pakistan" },
  { code: 322, name: "Palestina" },
  { code: 210, name: "Panama" },
  { code: 222, name: "Paraguay" },
  { code: 219, name: "Peru" },
  { code: 903, name: "Pesca Extra" },
  { code: 422, name: "Polinesia Fran" },
  { code: 528, name: "Polonia" },
  { code: 501, name: "Portugal" },
  { code: 412, name: "Ppua Nva Guinea" },
  { code: 251, name: "Puerto Rico" },
  { code: 312, name: "Qatar" },
  { code: 902, name: "Rancho De Naves" },
  { code: 510, name: "Reino Unido" },
  { code: 148, name: "Rep Cent Afric" },
  { code: 143, name: "Rep Dem Congo" },
  { code: 206, name: "Rep Dominicana" },
  { code: 545, name: "Rep Eslovaca" },
  { code: 544, name: "Republica Checa" },
  { code: 546, name: "Republica De Se" },
  { code: 346, name: "Republica De Ye" },
  { code: 334, name: "Rpd Corea Del N" },
  { code: 519, name: "Rumania" },
  { code: 562, name: "Rusia" },
  { code: 142, name: "Rwanda" },
  { code: 146, name: "S Tom Principe" },
  { code: 234, name: "S Vte Y Granad" },
  { code: 165, name: "Saharaui" },
  { code: 404, name: "Samoa Occ" },
  { code: 536, name: "San Marino" },
  { code: 233, name: "Santa Lucia" },
  { code: 524, name: "Santa Sede" },
  { code: 101, name: "Senegal" },
  { code: 156, name: "Seychelles" },
  { code: 105, name: "Sierra Leona" },
  { code: 332, name: "Singapur" },
  { code: 310, name: "Siria" },
  { code: 241, name: "Snt Kit And Nevis" },
  { code: 138, name: "Somalia" },
  { code: 314, name: "Sri Lanka" },
  { code: 112, name: "Sudafrica" },
  { code: 123, name: "Sudan" },
  { code: 160, name: "Sudan Del Sur" },
  { code: 511, name: "Suecia" },
  { code: 508, name: "Suiza" },
  { code: 235, name: "Surinam" },
  { code: 122, name: "Swazilandia" },
  { code: 409, name: "T Norteam En Op" },
  { code: 557, name: "Tadjikistan" },
  { code: 330, name: "Taiwan Formosa" },
  { code: 135, name: "Tanzania" },
  { code: 152, name: "Ter Espan En Af" },
  { code: 229, name: "Ter Holan En Am" },
  { code: 343, name: "Ter Portug Eas" },
  { code: 151, name: "Terr Brit En Af" },
  { code: 227, name: "Terr Brit En Am" },
  { code: 407, name: "Terr Brit En Op" },
  { code: 230, name: "Terr D Dinamarc" },
  { code: 153, name: "Terr Fran En Af" },
  { code: 228, name: "Terr Fran En Am" },
  { code: 408, name: "Terr Fran En Op" },
  { code: 319, name: "Thailandia" },
  { code: 426, name: "Timor Oriental" },
  { code: 109, name: "Togo" },
  { code: 203, name: "Trinid Y Tobago" },
  { code: 126, name: "Tunez" },
  { code: 248, name: "Turcas Y Caicos" },
  { code: 558, name: "Turkmenistan" },
  { code: 522, name: "Turquia" },
  { code: 419, name: "Tuvalu" },
  { code: 521, name: "U R S S" },
  { code: 225, name: "U S A" },
  { code: 559, name: "Ucrania" },
  { code: 136, name: "Uganda" },
  { code: 223, name: "Uruguay" },
  { code: 560, name: "Uzbekistan" },
  { code: 415, name: "Vanuatu" },
  { code: 201, name: "Venezuela" },
  { code: 325, name: "Vietnam" },
  { code: 117, name: "Zambia" },
  { code: 910, name: "Zf Arica Zf Ind" },
  { code: 905, name: "Zf Iquique" },
  { code: 907, name: "Zf Parenas" },
  { code: 116, name: "Zimbabwe" },
];
